import CouponMarketplaceModal from './coupon-marketplace-modal-view'

export default CouponMarketplaceModal
